import {
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';
import {
	ILanguageSelector,
	LanguageEnum
} from '@models/language';
import {
	ILanguageSelectorConfig,
	LANGUAGE_SELECTOR_CONFIG
} from '@shared/components/language-selector/language-selector.config';

@Component( {
	selector: 'app-language-selector[supportedLanguages]',
	templateUrl: './language-selector.component.html',
	styleUrls: [ './language-selector.component.scss' ]
} )
export class LanguageSelectorComponent {

	private readonly _languageSelectorConfig: ILanguageSelectorConfig = LANGUAGE_SELECTOR_CONFIG;
	private _defaultLanguage: LanguageEnum = this._languageSelectorConfig.defaultLanguage;
	private _supportedLanguages: ILanguageSelector[];
	private _selectedLanguageShortCode: LanguageEnum;
	selectedLanguageLocalName: string;

	@Input() fallbackToDefaultLanguage: boolean;
	@Input() languageSelectPlaceholder: string;

	@Input() set selectedLanguageShortCode( selectedLanguageShortCode: LanguageEnum ) {
		this._selectedLanguageShortCode = selectedLanguageShortCode;
		this.init();
	}

	@Input() set supportedLanguages( supportedLanguages: ILanguageSelector[] ) {
		this._supportedLanguages = supportedLanguages;
		this.init();
	}

	get supportedLanguages(): ILanguageSelector[] {
		return this._supportedLanguages;
	}

	@Output() languageChangeEvent: EventEmitter<LanguageEnum> = new EventEmitter();

	/**
	 * Reentrant init to prevent sync troubles between selectedLanguageShortCode & supportedLanguages.
	 */
	private init(): void {
		if ( !this.supportedLanguages ) { return; }

		this.setLanguageLocalName( this._selectedLanguageShortCode );

		if ( !this.selectedLanguageLocalName && this.fallbackToDefaultLanguage ) {
			this.setLanguageLocalName( this._defaultLanguage );
		}
	}

	private setLanguageLocalName( selectedLanguageShortCode: LanguageEnum ): void {
		const selectedLanguage = this.supportedLanguages?.find( ( language: ILanguageSelector ) =>
			language.shortCode === selectedLanguageShortCode
		);

		this.selectedLanguageLocalName = selectedLanguage?.localName;
	}

	onLanguageChange( languageSelector: ILanguageSelector ): void {
		this.setLanguageLocalName( languageSelector?.shortCode );
		this.languageChangeEvent.emit( languageSelector?.shortCode );
	}
}
